// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"0c362976","229":"2ed26b27","343":"9a3f8cc4","581":"f63da699","756":"df9543e6"}[chunkId] + ".chunk.css";
};